// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import { DataCacheProvider } from "./Services/DataCacheContext";


// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   // <React.StrictMode>
//     <DataCacheProvider>
//       <App />
//     </DataCacheProvider>
//   // {/* </React.StrictMode> */}
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./Styles/AppResponsive.css";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { loadConfig } from "./Config";

const root = ReactDOM.createRoot(document.getElementById("root"));

const renderApp = () => {
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
};

loadConfig()
  .catch((error) => {
    console.error("Failed to load runtime configuration:", error);
  })
  .finally(renderApp);